import React from 'react';

import { Toggle } from 'components';

import styles from 'components/lane/ChannelSettingsEdit/ChannelSettings.scss';

type InspectionsToggleProps = {
  channel: {
    settings: {
      hasInspectionsEnabled: boolean;
      hasWorkOrderServiceRequestsEnabled: boolean;
    };
  };
  onChannelUpdated: (update: {
    settings: { hasInspectionsEnabled: boolean };
  }) => void;
  disabled?: boolean;
};

export function InspectionsToggle({
  channel,
  onChannelUpdated,
  disabled = false,
}: InspectionsToggleProps) {
  const isDisabled =
    disabled || !channel.settings.hasWorkOrderServiceRequestsEnabled;

  return (
    <div className={styles.setting}>
      <Toggle
        disabled={isDisabled}
        className={styles.toggle}
        testId="toggleInspections"
        value={channel.settings.hasInspectionsEnabled || false}
        onChange={enabled =>
          onChannelUpdated({
            settings: {
              ...channel.settings,
              hasInspectionsEnabled: enabled,
            },
          })
        }
        text="web.content.feature.inspections.toggleFeature.title"
        description="web.content.feature.inspections.toggleFeature.description"
        doTranslate
      />
    </div>
  );
}
